import { useJamLeaderboard } from '@/src/store/jam-leaderboard.context';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { Link, Pagination, SpaceBetween, Toggle } from '@amzn/awsui-components-react';
import { useTranslation } from 'react-i18next';
import VirtualMCControls from '@/src/components/root/Footer/EventFooter/VirtualMCControls';
import styles from './LeaderboardFooter.module.scss';

export interface LeaderboardFooterProps {
  carouselIndex: number;
  onCarouselIndexChange: (index: number) => void;
  autoplay: boolean;
  onAutoplayChange: (value: boolean) => void;
  pagesCount: number;
}

export const LeaderboardFooter = (props: LeaderboardFooterProps) => {
  const { t } = useTranslation();
  const { isPresenterMode, togglePresenterMode, mouseMoved } = useJamLeaderboard();

  if (isPresenterMode && !mouseMoved) {
    return null;
  }

  return (
    <footer className={styles.footer}>
      <SpaceBetween direction="horizontal" size="s" alignItems="center">
        <Link onFollow={togglePresenterMode} href="" data-testid="leaderboard-presenter__toggle-mode-link">
          <span className={styles.presenterModeLink}>
            <img alt="" src="/assets/presenter.svg" />
            {!isPresenterMode ? t(i18nKeys.footer.presenterMode) : t(i18nKeys.footer.closePresenterMode)}
          </span>
        </Link>
        <VirtualMCControls />
      </SpaceBetween>
      {isPresenterMode && (
        <SpaceBetween direction="horizontal" size="m" alignItems="center">
          <Toggle
            checked={props.autoplay}
            onChange={({ detail }) => props.onAutoplayChange(detail.checked)}
            data-testid="leaderboard-presenter__cycle-toggle"
          >
            {props.autoplay
              ? t(i18nKeys.jamDashboard.leaderboard.cycleToggleActive)
              : t(i18nKeys.jamDashboard.leaderboard.cycleTogglePaused)}
          </Toggle>
          <Pagination
            currentPageIndex={props.carouselIndex + 1}
            onChange={({ detail }) => props.onCarouselIndexChange(detail.currentPageIndex - 1)}
            pagesCount={props.pagesCount}
            ariaLabels={{
              nextPageLabel: t(i18nKeys.challenges.nextPageLabel),
              paginationLabel: t(i18nKeys.challenges.paginationLabel),
              previousPageLabel: t(i18nKeys.challenges.previousPageLabel),
              pageLabel: (pageNumber) => `page ${pageNumber}`,
            }}
          />
        </SpaceBetween>
      )}
    </footer>
  );
};
